import StatsDashboard from "./subparts/StatsDashboard";


const Dashboard = () => {
  return (
     
        <><StatsDashboard /></>
    
  );
};

export default Dashboard;
